import { WorkflowEvent } from "../model";
import { Dates } from "../util/Dates";

/**
 * Logic class related to workflow features.
 */
export class WorkflowLogic {

  /**
   * Parses a workflow message string into an object. NOTE: Moved from WorkflowBadgeController.
   * @param messageString Message string which will be exploded into an object.
   * @returns Workflow event object.
   */
  public static parseWorkflowEventString(messageString: any): WorkflowEvent {
    // [type] (Ui[ui]):[message] ([User] at [yyyy-MM-dd HH:mm] to [assignedTo] id [id])
    const uiStartX = messageString.indexOf("(Ui");
    const uiEndX = messageString.indexOf("):", uiStartX + 3);
    const type = (messageString.substring(0, uiStartX - 1) || "");
    const ui = messageString.substring(uiStartX + 3, uiEndX).toLowerCase();
    let rest = messageString.substring(uiEndX + 3);
    const messageEndX = rest.lastIndexOf("(");
    const message = rest.substring(0, messageEndX).trim();
    rest = rest.substring(messageEndX + 1); // Remove (
    rest = rest.substring(0, rest.length - 1); // Remove )
    let id = "";
    const idx = rest.lastIndexOf(" id ");
    if (idx >= 0) {
      id = rest.substring(idx + 4);
      rest = rest.substring(0, idx);
    }
    let assignedTo = "";
    const aIdx = rest.lastIndexOf(" to ");
    if (aIdx >= 0) {
      assignedTo = rest.substring(aIdx + 4);
      rest = rest.substring(0, aIdx);
    }
    let time = "";
    const tIdx = rest.lastIndexOf(" at ");
    if (tIdx >= 0) {
      time = rest.substring(tIdx + 4);
      rest = rest.substring(0, tIdx);
      // time
      time = time.replace(" ", "T") + "Z";
    }
    const user = rest;
    return {
      id,
      type,
      ui,
      user,
      assignedTo,
      message,
      time,
    } as WorkflowEvent;
  }

  /**
   * Formats a workflow message object into a UI badge element.
   * @param message Object that holds the necessary data for badge.
   * @returns String of html.
   */
  public static formatWorkflowMessage = (message: WorkflowEvent): string => {
    const pvm = Dates.getDatelyObject(message.time);
    let formattedDateTime: string | undefined;
    if (pvm) {
      formattedDateTime = " at " + Dates.format(pvm, "DD.MM.YYYY HH.mm");
    } else {
      formattedDateTime = "";
    }

    const fullMessage = `${message.message} (${message.user}${formattedDateTime} id ${message.id})`;

    return `<div><span class='badge bg-${message.ui}' title='${fullMessage}'>${message.message}</span></div>`;
  };
}